/**
 * /tenants/$slug/directory/ad-inbound/new-workday — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { WorkdaySetupPage } from "@/features/directory/pages/workday-setup-page";

export const Route = createFileRoute("/_authed/tenants/$slug/directory/ad-inbound/new-workday")({
  component: WorkdaySetupPage,
});
